/**
 * AdMob の広告ユニットID。
 *
 * 本物のIDはビルドのときに環境変数で渡す（`.env.app.local` など。リポジトリには入れない）。
 *
 *   VITE_ADMOB_IOS_REWARDED / VITE_ADMOB_IOS_INTERSTITIAL
 *   VITE_ADMOB_ANDROID_REWARDED / VITE_ADMOB_ANDROID_INTERSTITIAL
 *
 * 渡さなければ **Google 公式のテスト用ID** になる。テスト用IDの広告は何度押しても
 * アカウントが止められない。本物のIDで自分の広告を押すと AdMob のアカウントが停止されることがあるので、
 * 開発中は必ずテスト用のまま動かす。
 *
 * アプリID（`ca-app-pub-…~…`）は JS ではなく、
 * android/app/src/main/AndroidManifest.xml と ios/App/App/Info.plist に書く（手順書を参照）。
 */

import type { NativeOS } from './native';

export interface AdUnits {
  rewarded: string;
  interstitial: string;
  /** Google のテスト用IDか。true のときは isTesting を付けて読み込む。 */
  testing: boolean;
}

/** https://developers.google.com/admob/android/test-ads ・ /ios/test-ads */
export const TEST_AD_UNITS: Record<NativeOS, Omit<AdUnits, 'testing'>> = {
  android: {
    rewarded: 'ca-app-pub-3940256099942544/5224354917',
    interstitial: 'ca-app-pub-3940256099942544/1033173712',
  },
  ios: {
    rewarded: 'ca-app-pub-3940256099942544/1712485313',
    interstitial: 'ca-app-pub-3940256099942544/4411468910',
  },
};

type Env = Record<string, string | undefined>;

export function adUnitsFor(os: NativeOS, env: Env = (import.meta.env ?? {}) as Env): AdUnits {
  const prefix = os === 'ios' ? 'VITE_ADMOB_IOS_' : 'VITE_ADMOB_ANDROID_';
  const rewarded = env[`${prefix}REWARDED`]?.trim();
  const interstitial = env[`${prefix}INTERSTITIAL`]?.trim();
  // 片方だけ本物、は事故のもとなので、両方そろったときだけ本物を使う
  if (rewarded && interstitial) return { rewarded, interstitial, testing: false };
  return { ...TEST_AD_UNITS[os], testing: true };
}
